import i18n from '@/api/i18n/i18n';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { getEmailClientsMailLink } from '@/api/methods/computers';

const typeDict = {
  31: i18n.t('pages.typeDict.incoming'),
  32: i18n.t('pages.typeDict.outgoing'),
};

export const type = (val) => typeDict[val];

export const openMail = (computerId, mailId) => {
  const url = getEmailClientsMailLink(computerId, mailId);
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const escapeRegExp = (value) => {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const getFilename = (headers) => {
  const disposition = headers['content-disposition'];

  const match = disposition?.match(/filename="?([^"]+)"?/);

  return match?.[1];
};

export const getExtension = (filename) => {
  if (!filename) {
    return 'eml';
  }

  const match = filename.match(/\.([^.]+)$/);

  return match ? match[1].toLowerCase() : 'eml';
};

export async function downloadZip(handlerBlob, handlerDownload, computerId, ids, log) {
  if (ids.length === 1) {
    handlerDownload(computerId, ids[0]);
    return;
  }
  const results = await Promise.allSettled(ids.map((id) => handlerBlob(computerId, id)));
  const zip = new JSZip();

  results.forEach((result, index) => {
    if (result.status !== 'fulfilled') {
      console.error(`Не удалось скачать ${ids[index]}`, result.reason);
      return;
    }

    const { headers, data } = result.value;
    const filename = getFilename(headers);
    zip.file(filename, data);
  });

  if (!Object.keys(zip.files).length) {
    throw new Error("Couldn't download any files");
  }

  const content = await zip.generateAsync({ type: 'blob' });

  saveAs(content, `${log}.zip`);
}
